export default "__VITE_ASSET__Dii6UL_C__"